import React, { Component } from 'react'
import { Col, Container, Modal, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

class BlogCard extends Component {

    state = {
        readBlog: false,
    }

    callModal = () => {
        const { readBlog } = this.state;
        if (readBlog) {
            this.setState({
                readBlog: false,
            })
        }
        else {
            this.setState({
                readBlog: true,
            })
        }
    }

    render() {

        const { blog } = this.props;
        const { readBlog } = this.state;
        const close = <FontAwesomeIcon icon={faTimes} />

        return (
            <div>
                <div
                    className="card border-0 h-100 shadow "
                >
                    <div className="card-img-top">
                        <img
                            src={blog.imageURL}
                            alt={blog.title}
                            className="img-fluid"
                        />
                    </div>
                    <div className="card-body text-center darkCard py-0">
                        <div className="card-title fs-4 pb-1 pt-2">
                            {blog.title}
                        </div>
                        <div className="text-secondary pb-2">Click to read</div>
                        <div className="stretched-link mymodal" onClick={this.callModal}></div>
                    </div>
                </div>
                <Modal show={readBlog} onHide={this.callModal} size="lg" contentClassName="border-0 font-monospace">

                    <Modal.Body className="lightCard px-0 py-0">
                        <div className="pb-2">
                            <button className="btn float-end" onClick={this.callModal}>
                                {close}
                            </button>
                        </div>
                        <Container>
                            <Row >
                                <Col xs={12} md={4} className="align-self-center">
                                    <div className="text-center">
                                        <img src={blog.imageURL} alt={blog.title} className="img-fluid py-3" />
                                    </div>
                                </Col>
                                <Col xs={12} md={8}>
                                    <div className="py-4 text-center">
                                        <div className="fs-2">{blog.title}</div>
                                        <div className="py-2">{blog.body}</div>
                                        <div className="text-secondary">{blog.date.toDate().toString().slice(0,15)}</div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>

                    </Modal.Body>

                </Modal>
            </div>
        )
    }
}

export default BlogCard;
